var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"tc-page-refine max-w-screen-xl mb-3 mx-auto sm:flex sm:items-center sm:space-x-3 px-6"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }